exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".next-slide-enter-active,.previous-slide-enter-active{transition:transform .5s ease}.next-slide-leave-active,.previous-slide-leave-active{transition:all .2s ease;position:absolute}.next-slide-enter{transform:translateX(50%) scale(.6)}.next-slide-leave-to,.previous-slide-leave-to{transform:translateX(0)}.previous-slide-enter{transform:translateX(-50%) scale(.6)}", ""]);

// exports
